import { Tenant } from "@/api/tenant.api";
import { ApiService } from "../api/api.service";
import { isAxiosError } from "axios";
import { TenantRoleDto, CreateRoleDto, UpdateRoleDto } from "@exibra/shared";

class TenantService extends ApiService {
    async getAvailableTenants(): Promise<Tenant[]> {
        const response = await this.axios.get<Tenant[]>("/tenants");
        return response.data;
    }

    async getTenant(id: number): Promise<Tenant | null> {
        try {
            const response = await this.axios.get<Tenant>(`/tenants/${id}`);
            return response.data;
        } catch (error) {
            if (
                isAxiosError(error) &&
                (error.response?.status === 403 || error.response?.status === 404)
            ) {
                return null;
            }
            throw error;
        }
    }

    async getTenantRoles(id: number): Promise<TenantRoleDto[]> {
        const response = await this.axios.get<TenantRoleDto[]>(`/tenants/${id}/roles`);
        return response.data;
    }

    async createTenantRole(tenantId: number, roleData: CreateRoleDto): Promise<TenantRoleDto> {
        const response = await this.axios.post<TenantRoleDto>(
            `/tenants/${tenantId}/roles`,
            roleData,
        );
        return response.data;
    }

    async updateTenantRole(
        tenantId: number,
        roleId: number,
        roleData: UpdateRoleDto,
    ): Promise<TenantRoleDto> {
        const response = await this.axios.put<TenantRoleDto>(
            `/tenants/${tenantId}/roles/${roleId}`,
            roleData,
        );
        return response.data;
    }

    async deleteTenantRole(tenantId: number, roleId: number): Promise<void> {
        await this.axios.delete(`/tenants/${tenantId}/roles/${roleId}`);
    }
}

export const tenantService = new TenantService();
